import { render, staticRenderFns } from "./processing-item-form.vue?vue&type=template&id=e0266342"
import script from "./processing-item-form.vue?vue&type=script&lang=js"
export * from "./processing-item-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports